export default "__VITE_ASSET__DJ0zUP1x__"